<template>
  <div class="appstore-icon-list">
    <ul>
      <li>
        <a href="https://itunes.apple.com/app/car2go/id514921710?mt=8" target="_blank" class="c2g-footer-ios-app-store">
          <img
            src="//images.ctfassets.net/ro7z507xvlp4/2o2oJJF7NOMe2YTawA7u5t/34b5e71a4c42bf45bded6f5d92d0323f/button-app-store-svg.svg"
            width="130"
            height="44"
            alt="Apple app store"
          />
        </a>
      </li>
      <li>
        <a href="https://play.google.com/store/apps/details?id=com.car2go" target="_blank" class="c2g-footer-android-app-store">
          <img
            src="//images.ctfassets.net/ro7z507xvlp4/l7NL08tUQOWv1qrHO5Jxs/d959f1aa8a5b0977f30bac4bc34bf4a6/google-play-badge_EN_FI.svg"
            width="130"
            height="44"
            alt="Google play store"
          />
        </a>
      </li>
    </ul>
  </div>
</template>
<script lang="ts">
export default {
  name: 'AppIconList',
};
</script>
<style src="./app-store-icon-list.component.scss" lang="scss"></style>
